"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderProvider = exports.HeaderContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _headerReducer = require("./headerReducer");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const HeaderContext = exports.HeaderContext = /*#__PURE__*/(0, _react.createContext)();
const HeaderProvider = _ref => {
  let {
    children
  } = _ref;
  const [state, dispatch] = (0, _react.useReducer)(_headerReducer.reducer, _headerReducer.initialState);
  const actions = {
    clickLogo: () => dispatch({
      type: _headerReducer.actionTypes.clickLogo
    }),
    clickBottomHome: () => dispatch({
      type: _headerReducer.actionTypes.clickBottomHome
    }),
    clickBottomSearch: () => dispatch({
      type: _headerReducer.actionTypes.clickBottomSearch
    }),
    clickCloseModal: () => dispatch({
      type: _headerReducer.actionTypes.clickCloseModal
    }),
    clickClearSearchbar: () => dispatch({
      type: _headerReducer.actionTypes.clickClearSearchbar
    }),
    typing: newInputValue => dispatch({
      type: _headerReducer.actionTypes.typing,
      newInputValue
    }),
    submitSearch: newInputValue => dispatch({
      type: _headerReducer.actionTypes.submitSearch,
      newInputValue
    }),
    openDrawer: () => dispatch({
      type: _headerReducer.actionTypes.openDrawer
    }),
    closeDrawer: () => dispatch({
      type: _headerReducer.actionTypes.closeDrawer
    }),
    backToSearchResult: () => dispatch({
      type: _headerReducer.actionTypes.backToSearchResult
    }),
    openNavigateMenu: () => dispatch({
      type: _headerReducer.actionTypes.openNavigateMenu
    }),
    closeNavigateMenu: () => dispatch({
      type: _headerReducer.actionTypes.closeNavigateMenu
    })
  };
  return /*#__PURE__*/_react.default.createElement(HeaderContext.Provider, {
    value: {
      state,
      actions
    }
  }, children);
};
exports.HeaderProvider = HeaderProvider;
HeaderProvider.propTypes = {
  children: _propTypes.default.node.isRequired
};